<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card :loading="isLoading">
        <v-card-title>
          <span class="headline">{{ modalTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-alert v-if="isEditing" border="left" colored-border type="info" elevation="2" class="mb-5">
           {{ entity }} já possui um link de compartilhamento ativo. Você pode editar suas opções ou revogá-lo.
          </v-alert>

          <v-container>
            <v-row>
              <v-col cols="12">
                <p class="subtitle-1">1. Período de Visualização</p>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-menu v-model="menu_initial_date" :close-on-content-click="false" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="formattedInitialDate" label="Data Inicial" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="config.initial_date" @input="menu_initial_date = false" locale="pt-br" no-title></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-menu v-model="menu_final_date" :close-on-content-click="false" transition="scale-transition" offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="formattedFinalDate" label="Data Final" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on"></v-text-field>
                      </template>
                      <v-date-picker v-model="config.final_date" @input="menu_final_date = false" locale="pt-br" no-title></v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-col>

              <v-col cols="12">
                <p class="subtitle-1">2. Opções de Exibição</p>
                <v-checkbox v-model="config.show_professional_name" label="Nome do profissional"></v-checkbox>
                <v-checkbox v-model="config.show_professional_photo" label="Foto do profissional"></v-checkbox>
                <v-checkbox v-model="config.show_available_shifts" label="Plantões disponíveis"></v-checkbox>
                <v-checkbox v-model="config.show_checkin_checkout" label="Check-in / Check-out"></v-checkbox>
                <v-checkbox v-model="config.show_checkin_location" label="Localização ponto (Check-in/out)"></v-checkbox>
                <v-checkbox v-model="config.show_shift_value" label="Valor do plantão"></v-checkbox>
                <v-checkbox v-model="config.show_shift_details" label="Local, horário e tipo do plantão"></v-checkbox>
                <v-checkbox v-model="config.show_professional_crm" label="CRM do profissional"></v-checkbox>
                <v-checkbox v-model="config.show_professional_phone" label="Telefone do profissional" @change="handlePhoneCheckboxChange"></v-checkbox>
                <v-checkbox
                  v-model="config.show_contact_list"
                  label="Lista de contatos dos profissionais"
                  @change="handleContactListChange"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn v-if="isEditing" color="red darken-1" text @click="revokeLink">
            Revogar Link
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close">
            Cancelar
          </v-btn>
          <v-btn color="blue darken-1" text @click="submit">
            {{ submitButtonText }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lgpdWarningDialog" persistent max-width="500px">
      <v-card>
        <v-card-title class="headline warning--text">
          <v-icon left color="warning">mdi-shield-alert-outline</v-icon>
          Aviso de Privacidade (LGPD)
        </v-card-title>
        <v-card-text class="pt-4">
          <p>
            Ao habilitar a opção <strong>"Telefone do profissional"</strong>, você estará compartilhando um dado pessoal sensível.
          </p>
          <p>
            Certifique-se de que você tem a permissão do profissional e que o compartilhamento deste dado está em conformidade com a Lei Geral de Proteção de Dados (LGPD - Lei nº 13.709/2018).
          </p>
          <p class="font-weight-bold">
            Deseja continuar e exibir o telefone dos profissionais no link compartilhado?
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelLgpd">
            Cancelar
          </v-btn>
          <v-btn color="warning" text @click="confirmLgpd">
            Confirmar e Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { FETCH_LINK_BY_SCALE_ID, REVOKE_LINK, UPDATE_LINK, FETCH_LINK_BY_GROUP_ID} from '../store/share-scale/types';

const formatDateForPicker = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset).toISOString().substr(0, 10);
};

export default {
  name: 'ShareScaleConfigModal',
  data() {
    return {
      dialog: false,
      isLoading: false,
      scale: null,
      existingLink: null,
      menu_initial_date: false,
      menu_final_date: false,
      lgpdWarningDialog: false,
      lgpdTrigger: null,
      config: {},
    };
  },
  computed: {
    isEditing() {
      return this.existingLink !== null;
    },
    modalTitle() {
      if (!this.scale?.scaleID) {
      return 'Compartilhar Plantões do Grupo';
      }
      return this.isEditing ? 'Gerenciar Link Compartilhado' : 'Compartilhar Escala com Opções';
    },
    submitButtonText() {
      return this.isEditing ? 'Salvar Alterações' : 'Gerar Link';
    },
    entity() {
      return this.scale?.scaleID ? 'Esta escala' : 'Este grupo';
    },
    formattedInitialDate() {
      if (!this.config.initial_date) return '';
      const [year, month, day] = this.config.initial_date.split('-');
      return `${day}/${month}/${year}`;
    },
    formattedFinalDate() {
      if (!this.config.final_date) return '';
      const [year, month, day] = this.config.final_date.split('-');
      return `${day}/${month}/${year}`;
    }
  },
  methods: {
    ...mapActions('shareScale', [FETCH_LINK_BY_SCALE_ID, REVOKE_LINK, UPDATE_LINK, FETCH_LINK_BY_GROUP_ID]),

    async open(scale) {
      this.resetConfigToDefaults();
      this.scale = scale;
      this.isLoading = true;
      this.dialog = true;

      try {
        let linkData;
        if (this.scale?.scaleID) {
          const response = await this.FETCH_LINK_BY_SCALE_ID(this.scale.scaleID);
          linkData = response?.data || null;
        } else {
          const response = await this.FETCH_LINK_BY_GROUP_ID(this.$route.params.groupID);
          linkData = response?.data || null;
        }
        this.existingLink = linkData;

        if (this.isEditing) {
          this.config = {
            initial_date: formatDateForPicker(this.existingLink.valid_from),
            final_date: formatDateForPicker(this.existingLink.valid_to),
            show_professional_name: this.existingLink.show_professional_name,
            show_professional_photo: this.existingLink.show_professional_photo,
            show_available_shifts: this.existingLink.show_available_shifts,
            show_checkin_checkout: this.existingLink.show_checkin_checkout,
            show_shift_value: this.existingLink.show_shift_value,
            show_shift_details: this.existingLink.show_shift_details,
            show_checkin_location: this.existingLink.show_checkin_location,
            show_professional_crm: this.existingLink.show_professional_crm,
            show_professional_phone: this.existingLink.show_professional_phone,
            show_contact_list: this.existingLink.show_contact_list,
          };
        }
      } catch (error) {

        if (error.response?.status !== 404) {
            this.$emit('showError', error.message || 'Erro ao carregar dados do link.');
        }
        this.existingLink = null;
      } finally {
        this.isLoading = false;
      }
    },

    handleContactListChange(isChecked) {
      if (isChecked) {
        this.config.show_professional_name = true;
        this.config.show_professional_photo = true;
        this.config.show_professional_crm = true;

        if (!this.config.show_professional_phone) {
          this.config.show_professional_phone = true;
          this.lgpdTrigger = 'contact_list';
          this.lgpdWarningDialog = true;
        }
      }
    },

    handlePhoneCheckboxChange(isChecked) {
      if (isChecked) {
        this.lgpdTrigger = 'phone';
        this.lgpdWarningDialog = true;
      } else {
        if (this.config.show_contact_list) {
          this.config.show_contact_list = false;
        }
      }
    },

    confirmLgpd() {
      this.lgpdWarningDialog = false;
      this.lgpdTrigger = null;
    },

    cancelLgpd() {
      this.config.show_professional_phone = false;

      if (this.lgpdTrigger === 'contact_list') {
        this.config.show_contact_list = false;
      }

      this.lgpdWarningDialog = false;
      this.lgpdTrigger = null;
    },

    submit() {
      const finalConfig = {
        ...this.config,
        scaleId: this.scale?.scaleID,
        groupId: this.$route.params.groupID,
      };

      if (this.isEditing) {
        this.$emit('updateLink', { linkId: this.existingLink.id, config: finalConfig });
      } else {
        this.$emit('generateLink', finalConfig);
      }
      this.close();
    },

    async revokeLink() {
      if (!this.isEditing) return;
      this.isLoading = true;
      try {
        await this.REVOKE_LINK(this.existingLink.id);
        this.$emit('showSuccess', 'Link revogado com sucesso!');
        this.close();
      } catch (error) {
        this.$emit('showError', error.message || 'Não foi possível revogar o link.');
      } finally {
        this.isLoading = false;
      }
    },

    resetConfigToDefaults() {
      this.existingLink = null;
      this.config = {
        initial_date: new Date().toISOString().substr(0, 10),
        final_date: new Date(new Date().setMonth(new Date().getMonth() + 4)).toISOString().substr(0, 10),
        show_professional_name: true,
        show_professional_photo: true,
        show_available_shifts: true,
        show_checkin_checkout: false,
        show_shift_value: false,
        show_shift_details: true,
        show_professional_crm: false,
        show_professional_phone: false,
        show_contact_list: false,
        show_checkin_location: false,
      };
    },

    close() {
      this.dialog = false;
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.headline {
  font-weight: 500;
}
.subtitle-1 {
    font-weight: 500;
    margin-bottom: 10px;
}
</style>
